import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import LogoIcon from "../../assets/svg/Logo";
import FullButton from "../Buttons/FullButton";
import {
  BtnWrapper,
  CloseButton,
  DropdownItem,
  DropdownMenu,
  LogoWrapper,
  MobileDropdownMenu,
  MobileDropdownToggle,
  MobileMenu,
  MobileMenuIcon,
  MobileNavLink,
  NavInner,
  NavLinkItem,
  UlWrapper,
  UlWrapperRight,
  Wrapper,
} from "../../style/navbar.styles";
import { AuthContext } from "../../contexts/AuthContext";
import { FaUser } from "react-icons/fa";
import { logoutUser } from "../../utils/AuthHandler";

const defaultMenu = [
  { label: "Home", href: "/home" },
  {
    label: "For Talent",
    href: "/opportunities",
    subItems: [
      { label: "Opportunities", href: "/opportunities" },
      { label: "Internships", href: "/internships" },
      { label: "Mentorships", href: "/mentors" },
    ],
  },
  {
    label: "For Organizations",
    href: "/find-talent",
    subItems: [
      { label: "Find Talent", href: "/find-talent" },
      { label: "Request Demo", href: "/request-demo" },
    ],
  },
  { label: "Programs", href: "/programs" },
];

const talentMenu = [
  { label: "Dashboard", href: "/dashboard" },
  { label: "Opportunities", href: "/opportunities" },
  { label: "Internships", href: "/internships" },
  { label: "Mentors", href: "/mentors" },
  { label: "Programs", href: "/programs" },
];

const orgMenu = [
  { label: "Dashboard", href: "/dashboard" },
  { label: "Find Talent", href: "/find-talent" },
  { label: "Opportunities", href: "/opportunities" },
  { label: "Internships", href: "/internships" },
];

export default function TopNavbar() {
  const [y, setY] = useState(window.scrollY);
  const { user, isLoggedIn } = useContext(AuthContext);
  const userRole = user?.role || null;
  const [menuItems, setMenuItems] = useState(defaultMenu);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const location = useLocation();

  const mobileMenuRef = useRef(null);

  useEffect(() => {
    if (userRole === "talent") {
      setMenuItems(talentMenu);
    } else if (userRole === "organization") {
      setMenuItems(orgMenu);
    } else {
      setMenuItems(defaultMenu);
    }
  }, [userRole]);

  useEffect(() => {
    const handleScroll = () => setY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [y]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setMobileMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mobileMenuRef]);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <Wrapper
      className="flexCenter animate whiteBg"
      style={{ height: "80px", paddingTop: "8px" }}
    >
      <NavInner className="container flexSpaceCenter">
        <LogoWrapper>
          <a className="pointer flexNullCenter" href="/" smooth={true}>
            <LogoIcon />
          </a>
          <MobileMenuIcon onClick={toggleMobileMenu}>
            <span></span>
            <span></span>
            <span></span>
          </MobileMenuIcon>
        </LogoWrapper>
        <UlWrapper className="flexNullCenter">
          {menuItems.map((item, index) => (
            <React.Fragment key={index}>
              {item.subItems ? (
                <DropdownItem className="semiBold font15 pointer">
                  <a
                    className={
                      location.pathname.startsWith(item.href) ? "active" : ""
                    }
                    style={{ padding: "10px 15px" }}
                    href={item.href}
                    spy={true}
                    smooth={true}
                    offset={-80}
                  >
                    {item.label}
                  </a>
                  <DropdownMenu>
                    {item.subItems.map((subItem, subIndex) => (
                      <li key={subIndex}>
                        <a
                          className={
                            location.pathname.startsWith(subItem.href)
                              ? "active"
                              : ""
                          }
                          href={subItem.href}
                        >
                          {subItem.label}
                        </a>
                      </li>
                    ))}
                  </DropdownMenu>
                </DropdownItem>
              ) : (
                <li className="semiBold font15 pointer">
                  <a
                    className={
                      location.pathname.startsWith(item.href) ? "active" : ""
                    }
                    style={{ padding: "10px 15px" }}
                    href={item.href}
                    spy={true}
                    smooth={true}
                    offset={-80}
                  >
                    {item.label}
                  </a>
                </li>
              )}
            </React.Fragment>
          ))}
        </UlWrapper>
        <UlWrapperRight className="flexNullCenter">
          {isLoggedIn ? (
            <NavLinkItem className="semiBold font15 pointer">
              <a
                href="/my-profile"
                className="radius6 lightBg"
                style={{ padding: "10px 15px" }}
              >
                <FaUser />
                <span style={{ marginLeft: "6px" }}>Profile</span>
              </a>
            </NavLinkItem>
          ) : (
            <>
              <li className="semiBold font15 pointer">
                <a href="/login" style={{ padding: "10px 30px 10px 0" }}>
                  Log in
                </a>
              </li>
              <li className="semiBold font15 pointer flexCenter">
                <BtnWrapper>
                  <FullButton
                    title="Get Started"
                    action={() => (window.location.href = "/register")}
                  />
                </BtnWrapper>
              </li>
            </>
          )}
        </UlWrapperRight>

        {/* Mobile Navigation */}
        <MobileMenu ref={mobileMenuRef} isOpen={mobileMenuOpen}>
          <CloseButton onClick={toggleMobileMenu}>&times;</CloseButton>

          {menuItems.map((item, index) => (
            <div key={index}>
              {item.subItems ? (
                <>
                  <MobileDropdownToggle
                    onClick={() => toggleDropdown(index)}
                    className="semiBold font15"
                  >
                    {item.label}
                    <span>{openDropdown === index ? "−" : "+"}</span>
                  </MobileDropdownToggle>
                  <MobileDropdownMenu isOpen={openDropdown === index}>
                    {item.subItems.map((subItem, subIndex) => (
                      <li key={subIndex}>
                        <a
                          className={
                            location.pathname.startsWith(subItem.href)
                              ? "active"
                              : ""
                          }
                          href={subItem.href}
                        >
                          {subItem.label}
                        </a>
                      </li>
                    ))}
                  </MobileDropdownMenu>
                </>
              ) : (
                <MobileNavLink className="semiBold font15">
                  <a
                    className={
                      location.pathname.startsWith(item.href) ? "active" : ""
                    }
                    href={item.href}
                  >
                    {item.label}
                  </a>
                </MobileNavLink>
              )}
            </div>
          ))}

          <div className="mobile-auth">
            {isLoggedIn ? (
              <>
                <MobileNavLink className="semiBold font15">
                  <a href="/my-profile" className="profile-link">
                    My Profile
                  </a>
                </MobileNavLink>
                <MobileNavLink className="semiBold font15">
                  <a
                    href="/"
                    onClick={() => {
                      logoutUser();
                    }}
                    className="profile-link"
                  >
                    Logout
                  </a>
                </MobileNavLink>
              </>
            ) : (
              <>
                <MobileNavLink className="semiBold font15">
                  <a href="/login">Log in</a>
                </MobileNavLink>
                <div className="mobile-btn-wrapper">
                  <FullButton
                    title="Get Started"
                    action={() => (window.location.href = "/register")}
                  />
                </div>
              </>
            )}
          </div>
        </MobileMenu>
      </NavInner>
    </Wrapper>
  );
}
